export const filterArray = [
  {
    title: "Phase",
    key: "phase",
    values: [
      {key: "Pre-construction", value: "Pre-construction"},
      {key: "Work in progress", value: "Work in progress"},
      {key: "90% contracts purchased", value: "90% contracts purchased"},
      {key: "Historical", value: "Historical"},
    ]
  },
  {
    title: "Size (SQFT)",
    key: "size",
    values: [
      {key: "underTen", value: "under 10,000"},
      {key: "btw10And30", value: "10,000 - 30,000"},
      {key: "btw30And60", value: "30,000 - 60,000"},
      {key: "btw60And100", value: "60,000 - 100,000"},
      {key: "btw100And200", value: "100,000 - 200,000"},
      {key: "above200", value: "200,000 & above"}
    ]
  },
  {
    title: "Building Types",
    key: "building",
    values: [
      {key: "Multi-family", value: "Multi-family"},
      {key: "Multi-family residential", value: "Multi-family residential"},
      {key: "Education", value: "Education"},
      {key: "Industrial", value: "Industrial"},
      {key: "Medical-Dental", value: "Medical-Dental"},
      {key: "Police-Fire Station", value: "Police-Fire Station"},
      {key: "Bank", value: "Bank"},
      {key: "Worship", value: "Worship"},
      {key: "Renovation Addition", value: "Renovation Addition"},
      {key: "Interior tenant fit out", value: "Interior tenant fit out"},
      {key: "Airport", value: "Airport"},
      {key: "Community/Public", value: "Community/Public"},
      {key: "Interior tenant fit out", value: "Interior tenant fit out"},
      {key: "Car dealership", value: "Car dealership"}
    ]
  }
];